import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import {cons, intercalate, showArrayImpl, showCharImpl, showIntImpl, showNumberImpl, showStringImpl} from "./foreign.js";
const showString = {show: showStringImpl};
const showRecordFieldsNil = {showRecordFields: v => v1 => []};
const showRecordFields = dict => dict.showRecordFields;
const showRecord = () => () => dictShowRecordFields => (
  {
    show: record => {
      const v = dictShowRecordFields.showRecordFields(Type$dProxy.Proxy)(record);
      if (v.length === 0) { return "{}"; }
      return intercalate(" ")(["{", intercalate(", ")(v), "}"]);
    }
  }
);
const showProxy = {show: v => "Proxy"};
const showNumber = {show: showNumberImpl};
const showInt = {show: showIntImpl};
const showChar = {show: showCharImpl};
const showBoolean = {
  show: v => {
    if (v) { return "true"; }
    return "false";
  }
};
const show = dict => dict.show;
const showArray = dictShow => ({show: showArrayImpl(dictShow.show)});
const showRecordFieldsCons = dictIsSymbol => dictShowRecordFields => dictShow => (
  {
    showRecordFields: v => record => {
      const key = dictIsSymbol.reflectSymbol(Type$dProxy.Proxy);
      return cons(intercalate(": ")([key, dictShow.show(Record$dUnsafe.unsafeGet(key)(record))]))(dictShowRecordFields.showRecordFields(Type$dProxy.Proxy)(record));
    }
  }
);
export {show, showArray, showBoolean, showChar, showInt, showNumber, showProxy, showRecord, showRecordFields, showRecordFieldsCons, showRecordFieldsNil, showString};
export * from "./foreign.js";
